let authConfig: {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
} = {};

export function configureAuth(config: {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
}): void {
  authConfig = config;
}

export function setAuthCompanyId(companyId: string | undefined): void {
  authConfig = { ...authConfig, companyId };
}

export function getAuthConfig(): {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
} {
  return authConfig;
}

export async function authFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);

  // Capture tenant headers synchronously before any async work so that a
  // company switch mid-request doesn't cause this request to be sent with a
  // mismatched companyId (e.g. old project ID + new company).
  const instanceId = authConfig.instanceId;
  const companyId = authConfig.companyId;

  if (authConfig.getAccessToken) {
    try {
      const token = await authConfig.getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    } catch (error) {
      console.error("[authFetch] Error getting access token:", error);
    }
  }

  if (instanceId) {
    headers.set("X-Instance-Id", instanceId);
  }

  if (companyId) {
    headers.set("X-Company-Id", companyId);
  }

  return fetch(input, {
    ...init,
    headers,
  });
}
